export var TransactionRole;
(function (TransactionRole) {
    TransactionRole["SENDER"] = "SENDER";
    TransactionRole["RECIPIENT"] = "RECIPIENT";
})(TransactionRole || (TransactionRole = {}));
//# sourceMappingURL=transaction-role.enum.js.map